import { SupportedOrgs } from './storeConfig';

export interface DemoConfig {
  /** Hex without leading # — matches URL param format. */
  primaryColor: string;
  /** Hex without leading # — matches URL param format. */
  textColorOverride: string;
  /** Stringified boolean passed through to the iframe context. */
  navbar: 'true' | 'false';
  /** Fake contactId used to populate the simulated parent context. */
  contactId: string;
  /** Fake Salesforce contact id used to populate the simulated parent context. */
  salesforceId: string;
  /** Label for the third nav item, between Home/Events ("Brothers", "Sisters", "Members", ...). */
  membersLabel: string;
  /** Text shown in the topbar as the signed-in user. */
  signedInAs: string;
  /** Known Shopify collections for this org's demo selector. Position 0 is the default iframe src. */
  collectionHandles: string[];
}

export const DEMO_CONFIGS: Record<SupportedOrgs, DemoConfig> = {
  [SupportedOrgs.LCA]: {
    primaryColor: '663399',
    textColorOverride: 'FFFFFF',
    navbar: 'false',
    contactId: 'contact_lca_001',
    salesforceId: '003xx_LCA_PLACEHOLDER',
    membersLabel: 'Members',
    signedInAs: 'Test Member · contact_lca_001',
    collectionHandles: [
      'lca-portal-collection',
      'lca-portal-collection-first-job-essentials',
      'lca-portal-collection-brotherhood-material',
    ],
  },
  [SupportedOrgs.PDT]: {
    primaryColor: '0B2A6B',
    textColorOverride: 'FFFFFF',
    navbar: 'true',
    contactId: 'contact_pdt_001',
    salesforceId: '003xx_PDT_PLACEHOLDER',
    membersLabel: 'Brothers',
    signedInAs: 'Test Member · contact_pdt_001',
    collectionHandles: ['pdt-portal-collection', 'pdt-pins-and-manuals-portal-collection'],
  },
  [SupportedOrgs.AGD]: {
    primaryColor: '8B0000',
    textColorOverride: 'FFFFFF',
    navbar: 'false',
    contactId: 'contact_agd_001',
    salesforceId: '003xx_AGD_PLACEHOLDER',
    membersLabel: 'Sisters',
    signedInAs: 'Test Member · contact_agd_001',
    collectionHandles: [
      'agd-portal-collection',
      'alpha-gamma-delta-collegiate-portal-collection',
      'alpha-gamma-delta-alumnae-portal-collection',
    ],
  },
};
